import { registerComponents } from "@/helpers/async";

export default {
  install: (Vue: any) => {
    registerComponents(Vue, import.meta.glob("./*.vue"));
  }
};
